// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const Sessions = () => {

   const [time, set_time] = React.useState(0);

   var content   = [];

   var key_index = 1;

   const build = async ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      set_body(
         <div>
           {warn}
           <div className="ask-henry-body-margin-bottom-x"><input className="ask-henry-radio" name="time" type="radio" value={0} /> Just Today</div>
           <div className="ask-henry-body-margin-bottom-x"><input className="ask-henry-radio" name="time" type="radio" value={1} /> Yesterday</div>
           <div className="ask-henry-body-margin-bottom-x"><input className="ask-henry-radio" name="time" type="radio" value={2} /> Past Week</div>
           <div className="ask-henry-body-margin-bottom-x"><input className="ask-henry-radio" name="time" type="radio" value={3} /> Past Two Weeks</div>
           <div className="ask-henry-body-margin-bottom-x"><input className="ask-henry-radio" name="time" type="radio" value={4} /> Past 30 Days</div>
           <div className="ask-henry-body-margin-bottom-x"><input className="ask-henry-radio" name="time" type="radio" value={5} /> Monthly Summary</div>
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Submit{app.who()}</button>
           <button className="ask-henry-form-button" onClick={form_close} >Close</button>
         </>
      );

   } // build();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus a warning message
      // is set, otherwise the form state is set to ENACT;
      const list = document.getElementsByClassName('ask-henry-radio');
      var   time = -1;
      for (var ith = 0; ith < list.length; ith++) {
         if (list[ith].checked) {
            time = ith;
            break;
         }
      }
      if (-1 === time) {
         set_warn('Select a time period before you click the Submit button:');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_time(time);
         set_form(FORM.ENACT); // Send any requests to the API;
      }
   } // check();

   const enact = async ({ set_body, set_foot, set_form, set_pass, set_warn, pass, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      var response  = await api.fetch(
         'dbs/report/session/' + app.state.user_access_list[app.state.user_access_id].version_id, 
         api.post({ period:time }),
         api.token()
      );

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
         }
      } else {
         set_warn('');
      }

      const report = response.data.report;
      for (var ith = 1; ith < report.length; ith++) {
         if ((1 === ith) && (2 < report.length)) {
            content.push(
               <tr key={key_index++}>
                 <td className="ask-henry-body-center">{5 === time ? 'Month' : 'Session'}</td>
                 <td className="ask-henry-body-center">Chats</td>
                 <td className="ask-henry-body-center">Searches</td>
                 <td className="ask-henry-body-center">Topics</td>
                 <td className="ask-henry-body-center">Total<br/>Queries</td>
                 <td className="ask-henry-body-center">Positive<br/>Feedback</td>
                 <td className="ask-henry-body-center">Negative<br/>Feedback</td>
               </tr>
            );
         } if (ith === (report.length - 1)) {
            content.push(
               <tr key={key_index++}>
                 <td className="ask-henry-body-center">Total<br/>{5 === time ? 'Months' : 'Sessions'}</td>
                 <td className="ask-henry-body-center">Total<br/>Chats</td>
                 <td className="ask-henry-body-center">Total<br/>Searches</td>
                 <td className="ask-henry-body-center">Total<br/>Topics</td>
                 <td className="ask-henry-body-center">Total<br/>Queries</td>
                 <td className="ask-henry-body-center">Total<br/>Positive</td>
                 <td className="ask-henry-body-center">Total<br/>Negative</td>
               </tr>
            );
         }
         content.push(
            <tr key={key_index++}>
              <td className="ask-henry-body-center">{report[ith][0]}</td>
              <td className="ask-henry-body-center">{report[ith][1]}</td>
              <td className="ask-henry-body-center">{report[ith][2]}</td>
              <td className="ask-henry-body-center">{report[ith][3]}</td>
              <td className="ask-henry-body-center">{report[ith][4]}</td>
              <td className="ask-henry-body-center">{report[ith][5]}</td>
              <td className="ask-henry-body-center">{report[ith][6]}</td>
            </tr>
         );
      }

      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);

      set_body(
         <div className="ask-henry-form-delete-source-scroll">
           <div className="ask-henry-body-margin-bottom-x">Between {report[0][8]} and {report[0][10]}</div>
           <table className="ask-henry-data-grid">
             <tbody>
               {content}
             </tbody>
           </table>
        </div>
      );

      app.set_state('status', 'Session report generated');

   } // enact();

   return <Form build={build} check={check} class_string="ask-henry-form-delete-source" enact={enact} title={'Session Report' + app.who()} />

} // <Sessions />;

export default Sessions;
